module.exports = __webpack_public_path__ + "static/media/Advanced Material Exchange.28b5b96b.png";